module.exports = __webpack_public_path__ + "img/25.0c03dd88.jpg";